import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { faDumpster } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'

export const DumpRoute: TileRoleRoute = {
  path: 'dump',
  text: 'Dump',
  faIcon: faDumpster,
  element: (
    <ManagementGridFactory
      entity="tipologia_dump"
      referencesCollection="dumps"
      referencesTitle="Dump"
      displayField="ded_Dis"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Dump',
      icon: faDumpster,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
